import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormControl, FormLabel, FormGroup, FormControlLabel, Checkbox } from '@material-ui/core';

import useInitializeFilter from './useInitializeFilter';
import { getEnumSearchCriteria } from './filterHelpers';

const LineOfBusiness = ({
  handleSetSearchCriteria,
  setInitialQuery,
  setResetFunc,
  typeOfContainer,
}) => {
  const [selectedProducts, setSelectedProducts] = useState({});

  const resetComponent = () => {
    if (filterSpec?.searchTerm) {
      const newSelectedProducts = {};
      for (const product of filterSpec.values) {
        newSelectedProducts[product] = true;
      }
      setSelectedProducts(newSelectedProducts);
    }
  };

  // onChange handle for checkboxes. Only send the checked items to the searchCriteria
  const handleOnChange = (e) => {
    const { name, checked } = e.target;
    const newSelectedProducts = { ...selectedProducts, [name]: checked };
    setSelectedProducts(newSelectedProducts);

    const productKeys = Object.keys(newSelectedProducts);
    const criteria = [];
    for (const key of productKeys) {
      if (newSelectedProducts[key]) {
        criteria.push(key);
      }
    }

    handleSetSearchCriteria(filterSpec?.searchTerm, getEnumSearchCriteria(criteria));
  };

  const { filterSpec } = useInitializeFilter(typeOfContainer, 'LineOfBusiness', setInitialQuery);

  // on initialization, assign the reset pointer to ref and send initial search criteria
  useEffect(() => {
    if (filterSpec?.searchTerm?.length > 0) {
      resetComponent();
      setResetFunc(filterSpec?.searchTerm, resetComponent);
      handleSetSearchCriteria(filterSpec?.searchTerm, getEnumSearchCriteria(filterSpec?.values));
    }
  }, [filterSpec]);

  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">Line of Business</FormLabel>
      <FormGroup>
        {filterSpec?.values?.map((option) => (
          <FormControlLabel
            key={option}
            control={
              <Checkbox
                id={`brandfolder-lob-checkbox-${option}`}
                checked={selectedProducts[option] ?? false}
                onChange={handleOnChange}
                disabled={!filterSpec?.searchTerm}
                name={option}
              />
            }
            label={option}
          />
        ))}
      </FormGroup>
    </FormControl>
  );
};

LineOfBusiness.propTypes = {
  handleSetSearchCriteria: PropTypes.func,
  setInitialQuery: PropTypes.func,
  setResetFunc: PropTypes.func,
  typeOfContainer: PropTypes.oneOf(['Underwriting', 'Marketing', 'Training']),
};

export default LineOfBusiness;
